const _ = require('lib/underscore')
const InputView = require('./input_view')


const InputCheckboxView = InputView.extend({

    attribute_keys: [
        'type',
        'id',
        'name',
        'disabled',
        'checked',
        'value',
    ],

     
    constructor: function constructor() {
        InputView.apply(this, arguments)

        this.listenTo(this.model, 'change:checked', this.onModelChangeChecked)
    },

    onInputChange() {
        const checked = this.$el.is(':checked')
        this.model.set('checked', checked)
    },

    getInputValue() {
        const checked = this.$el.is(':checked')
        const value = this.model.get('value')

        if (_.isFunction(value)) {
            // if value is a function, evaluate it and return the result
            return value.call(this, checked)
        }

        // only return value if this is checked, else return undefined
        if (checked) return value
    },

    onModelChangeChecked(model, checked) {
        this.$el.prop('checked', checked)
    },

})

module.exports = InputCheckboxView
